<template>
  <v-container class="py-8 py-md-10 py-lg-12">
    <SearchHomeForm />

    <LoadingWidget v-if="loading" />

    <template v-else-if="items.length">
      <div
        class="
          text-body-2 text-sm-body-1 text-center
          font-weight-regular
          px-3
          mt-6 mt-md-8
        "
      >
        Sua busca retornou
        <span class="font-weight-bold">{{ totalItems }}</span> resultado(s)
      </div>

      <div class="justify-center mt-6 mt-md-8 grid-list">
        <PropertyCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
        />
      </div>

      <PaginationWidget
        v-if="countPages > 1"
        class="mt-8 mt-md-10"
        :count="countPages"
      />
    </template>
    <v-alert v-else class="mt-8 mt-md-10 mt-lg-12" type="info">
      Nenhum imóvel encontrado
    </v-alert>
  </v-container>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import SearchHomeForm from "../components/forms/SearchHomeForm.vue";
import PropertyCard from "../components/cards/PropertyCard.vue";
import PaginationWidget from "../components/widgets/PaginationWidget.vue";

const _config = {
  mod: "properties",
};

const _pagination = {
  itemsPerPage: 24,
  returnTotalItems: 1,
};

const _data = {
  loading: true,
  items: [],
  totalItems: 0,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    query() {
      return this.$route.query;
    },
    page() {
      return this.query.p;
    },
    categories() {
      return this.$rest("categories").list;
    },
    category() {
      if (this.query.tipo) return this.query.tipo;

      return this.categories;
    },
    district() {
      return this.query.bairro;
    },
    reference() {
      return this.query.referencia;
    },
    countPages() {
      return Math.ceil(this.totalItems / _pagination.itemsPerPage);
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getList() {
      this.loading = true;

      const params = { ..._pagination };

      if (this.page) params.page = this.page;
      if (this.category) params.category = this.category;
      if (this.district) params.district = this.district;
      if (this.reference) params.reference = this.reference;

      this.$rest(_config.mod)
        .get({
          params,
          save: (state, data) => {
            if (data?.list?.length) {
              this.items = data.list;
              this.totalItems = data.totalItems;
            } else this.items = data;
          },
        })
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    "$route.query"() {
      this.getList();
    },
    categories(v) {
      if (v.length) this.getList();
    },
  },
  created() {
    this.$rest("categories").get();
  },
  components: {
    LoadingWidget,
    SearchHomeForm,
    PropertyCard,
    PaginationWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 20px 12px;
  grid-template-columns: repeat(auto-fit, 300px);

  @media screen and (max-width: 959.9px) {
    grid-template-columns: repeat(2, calc(50% - 6px));
  }

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}
</style>
